import { observer } from 'mobx-react-lite';
import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useStores } from '../../../hooks';
import { Progress, Button, Icon } from 'semantic-ui-react';

import {
  BreadcrumbContainer,
  DashboardCard,
  SideNavContainer,
  TopBarContainer,
} from '../../../components/Dashboard';

import { PageLoaderWithMessagesHandler, Selection } from '../../../elements';
import { useComponentWillMount } from '../../../hooks/useComponentWillMount';
import { auctionType, auctionTypes, getPath } from './../../../data/';
import {
  Layout,
  MainContainer,
  PageNavContainer,
  PageNavLeftContainer,
  PageNavRightContainer,
  PageNavCenterContainer,
} from './Styles';
import { formatDateTimeOnlyWithSeconds } from '../../../shared/utils/dateTime';

const paths = getPath();
const breadcrumbs = paths.dashboard.breadcrumbs;

const AdminLayout = () => {
  const {
    APIWebSocketStore: { connection, disconnect, handleReconnect },
    AuthStore: { memberName },
    DashboardStore: {
      auctionMetricList,
      connected,
      isLoading,
      loadDashboardMetricsFromAPI,
      emitTimestamp,
    },
    UIStore: { setHeaderText },
  } = useStores();

  const pendingState = '6797BDA6-A864-EB11-80CF-005056AFAEEA';

  const defaultAuctionState = {
    text: auctionType.pending.text,
    value: auctionType.pending.value,
  };
  const [auctionState, setAuctionState] = useState(defaultAuctionState);
  // console.log('auctionState', {auctionState, connection, connected, isLoading});
  useComponentWillMount(() => {
    if (connection) return;
    handleReconnect();
  });

  const onAuctionStateChanged = (value, text) => {
    setAuctionState({ text, value });
    if (value !== auctionType.pending.value) {
      disconnect();
      loadDashboardMetricsFromAPI(value);
    }
    if (value === auctionType.pending.value) {
      handleReconnect();
    }
    setHeaderText(text);
  };

  const noAuctionsFound = !auctionMetricList || !auctionMetricList?.length;
  useEffect(() => {
    setHeaderText(auctionState?.text);

    if (auctionState.text === 'Pending Auctions' && !connected) {
      handleReconnect();
    }
  }, []);

  // useEffect(() => {
  //   progressIndicator.current = true;
  //   setTimeout(() => {
  //     progressIndicator.current = false;
  //     console.log('pi', progressIndicator.current);
  //   }, 1000);
  //   console.log('pi', progressIndicator.current);
  // }, [emitTimestamp]);

  return (
    <Layout>
      <TopBarContainer
        connected={connected}
        laneName={`auctionLaneName`}
        // auctionAndLaneName={auctionState.text}
        memberName={memberName}
        showLogout
        title={`Dashboard`}
      />
      <SideNavContainer
      // auctionList={auctionList}
      // currentAuctionId={auctionList && auctionID}
      // laneList={laneList}
      // currentLaneId={laneList && auctionLaneId}
      // runList={runList}
      // currentLotNumber={45824}
      // totalBiddersInLane={laneMetrics && laneMetrics.totalBiddersInLane}
      // handleAuctionChange={(e) => handleJoinAuction(e.target.value)}
      // handleLaneChange={(e) => handleJoinLane(e.target.value)}
      // handleOpenItemClick={handleOpenItemClick}
      />

      <PageNavContainer>
        <PageNavLeftContainer>
          <BreadcrumbContainer>
            {breadcrumbs.map(({ label, to }) =>
              to ? (
                <Link key={to} to={to}>
                  {label}
                </Link>
              ) : (
                label
              ),
            )}
          </BreadcrumbContainer>
        </PageNavLeftContainer>
        <PageNavCenterContainer>
          {auctionState.value === pendingState && (
            <SocketConnectionIndicator handleReconnect={handleReconnect} />
          )}
        </PageNavCenterContainer>
        <PageNavRightContainer>
          <Selection
            defaultValue={auctionState.value}
            onChange={onAuctionStateChanged}
            options={auctionTypes}
            testId="auction-state-dropdown"
            title="Views"
          />
        </PageNavRightContainer>
      </PageNavContainer>
      <MainContainer>
        <PageLoaderWithMessagesHandler
          isLoading={isLoading}
          noDataFound={noAuctionsFound}
          topic={auctionState.text}
        >
          {auctionMetricList?.map((item) => {
            return (
              <DashboardCard
                key={`dcard_${item.auctionID}-${item.productStatusedCount}-${item.totalItemsUploaded}`}
                auctionID={item.auctionID}
                laneMetricList={item.laneMetricList}
                totalItems={item.totalItems}
                itemName={item.auction}
                productNonStatusedCount={item.productNonStatusedCount}
                productStatusedCount={item.productStatusedCount}
                productTotalCount={item.productTotalCount}
                totalItemsUploaded={item.totalItemsUploaded}
                totalItemsPending={item.totalItemsPending}
                totalItemsError={item.totalItemsError}
                proxyBidCount={item.proxyBidCount}
                registeredMembers={item.registeredMembers}
                registeredUsers={item.registeredUsers}
                uniqueUsers={item.uniqueRegisteredUsers}
                startTime={item.startTime}
                endTime={item.endTime}
                onClick={() => {
                  disconnect();
                }}
              />
            );
          })}
        </PageLoaderWithMessagesHandler>
      </MainContainer>
    </Layout>
  );
};

export default observer(AdminLayout);

export const SocketConnectionIndicator = observer(({ handleReconnect }) => {
  const {
    DashboardStore: { emitTimestamp, connected },
  } = useStores();

  const [indicator, setIndicator] = useState(true);

  useEffect(() => {
    let isMounted = true;
    if (!connected) handleReconnect();
    setIndicator(connected);
    setTimeout(() => {
      if (isMounted) {
        setIndicator(false);
      }
    }, 1500);

    // console.log('SocketConnectionIndictor', {
    //   emitTimestamp,
    //   connected,
    // });

    return () => {
      isMounted = false;
    };
  }, [emitTimestamp, connected]);

  return (
    <>
      {connected ? (
        <Progress percent={100} indicating={indicator} success={!indicator}>
          <Button
            className="progress"
            loading={indicator}
            basic
            onClick={() => (window.location.href = window.location.href)}
          >
            <Icon name="refresh" />
            {` CONNECTED... (LAST EMIT: ${formatDateTimeOnlyWithSeconds(
              emitTimestamp,
            )})`}
          </Button>
        </Progress>
      ) : (
        <Progress percent={100} error>
          <Button
            icon
            className="error"
            basic
            onClick={() => (window.location.href = window.location.href)}
          >
            <Icon name="refresh" />
            NOT CONNECTED - CLICK TO CONNECT
          </Button>
        </Progress>
      )}
    </>
  );
});
